import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/es6.array.find.js";

function nextLevel(item, key, compare) {
  // if object, return property value with name key
  if (_typeof(item) === 'object') {
    return item[key];
  } // if array, return result of find where array element property with name === compare matches key


  if (Array.isArray(item)) {
    return item.find(function (v) {
      return v[compare] === key;
    });
  } // else return undefined


  return;
}

function endOfTheRoad(item, test) {
  // if test requested, return result of test
  if (test) {
    return typeof test === 'function' && test(item);
  } // finally, if we made it this deep, the item must be defined!


  return true;
}
/**
 * Recursive function to dig in to a nest of objects or arrays and check for the existence
 * of a valid value
 *
 * @param {Mixed} item the item to dig in to
 * @param {array} keys array of keys
 * @param {String} compare (optional) alters the property compared in the array find operation
 * @param {Object} index (optional) (default = 0) current index or 'level deep'
 * @param {Function} test (optional) (default = null) a callback to test the end value (should return true if value accepted as legitimate)
 *
 * @returns {Boolean} True if valid value exists at the end of the path described by the keys
 */


export var goDeeper = function goDeeper(item, keys) {
  var compare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var test = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  // if item or keys undefined, return false
  if (typeof item === 'undefined' || typeof keys === 'undefined') {
    return false;
  } // if final level, return final value, else, go deeper


  if (index === keys.length) {
    return endOfTheRoad(item, test);
  }

  var deeper = nextLevel(item, keys[index], compare);
  index++; // increment index and go deeper

  return goDeeper(deeper, keys, compare, index, test);
};
export default {
  goDeeper: goDeeper
};